export const REHIRE_ELIGIBLE_TYPES = {
  YES: 'YES',
  NO: 'NO',
  DONT_KNOW: 'DONT_KNOW',
} as const;

export const RehireEligibleText = {
  YES: 'Yes',
  NO: 'No',
  DONT_KNOW: "Don't know",
};
